import { _ } from '../../utils/l10n';
import { ButtonMode } from '../../types';
import { ButtonTypes } from '../../consts/button';

export interface SignInButtonProps {
  /**
   * Sign in button class name
   */
  className?: string;
  /**
   * Indicates whether button mode should be secondary
   */
  isSecondary?: boolean;
}

export const SignInButton = (
  {
    className,
    isSecondary,
  }: SignInButtonProps,
) => {
  const mode = (isSecondary ? ButtonTypes.SECONDARY : ButtonTypes.OUTLINE) as ButtonMode;

  return (
    <a
      className={`button ${mode} medium ${className || ''}`}
      href='https://twex.app/login/'
      target='_blank'
    >
      {_('Sign in')}
    </a>
  );
};
